import { render, staticRenderFns } from "./AddDictType.vue?vue&type=template&id=9d77f9be&scoped=true&"
import script from "./AddDictType.vue?vue&type=script&lang=js&"
export * from "./AddDictType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d77f9be",
  null
  
)

export default component.exports